<template>
  <div>
    <h1 class="has-text-centered is-size-3 has-text-weight-bold is-padded-small has-text-white">
      CBRN TOOLBOX
    </h1>
    <b-columns
      class="is-centered"
      is-fluid
    >
      <b-column class="is-narrow">
        <descriptive-link path-to="/observations">
          <template v-slot:icon>
            <img
              :src="ObservationsLogo"
              alt="Observations filter"
            >
          </template>
          <section>
            <h2 class="has-text-weight-bold is-size-5 has-margin-bottom-small">
              OBSERVATIONS FILTER
            </h2>
            <p class="is-size-6 has-text-weight-semibold wrap-text">
              Identify an agent by filtering with observations
            </p>
          </section>
        </descriptive-link>
      </b-column>
      <b-column class="is-narrow">
        <descriptive-link path-to="/agents">
          <template v-slot:icon>
            <img
              :src="AgentListLogo"
              alt="Agent list"
            >
          </template>
          <section>
            <h2 class="has-text-weight-bold is-size-5 has-margin-bottom-small">
              AGENT LIST
            </h2>
            <p class="is-size-6 has-text-weight-semibold wrap-text">
              Search agents by name from the list of all agents
            </p>
          </section>
        </descriptive-link>
      </b-column>
      <b-column class="is-narrow">
        <descriptive-link path-to="/material-portal">
          <template v-slot:icon>
            <img
              :src="MaterialPortalLogo"
              alt="Material Portal"
            >
          </template>
          <section>
            <h2 class="has-text-weight-bold is-size-5 has-margin-bottom-small">
              MATERIAL PORTAL
            </h2>
            <p class="is-size-6 has-text-weight-semibold wrap-text">
              See all the protocol and other study material
            </p>
          </section>
        </descriptive-link>
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import MaterialPortalLogo from '@/assets/home-view-material-portal-logo.png'
import AgentListLogo from '@/assets/home-view-agents-logo.png'
import ObservationsLogo from '@/assets/home-view-filter-logo.png'
import DescriptiveLink from '@/components/home/DescriptiveLink'

export default {
  components: {
    DescriptiveLink
  },
  data () {
    return {
      MaterialPortalLogo,
      AgentListLogo,
      ObservationsLogo
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/colorpallet.scss";

.is-narrow {
  padding: 1.5rem;
}

section {
  p {
    display: inline-block;
    max-width: 80%;
  }
}
</style>
